import * as React from "react";
import {cx} from "emotion";

import "./non-subsx-benefits.scss";

import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {Load2}            from "@Common/react/load2";
import {DomSizeObserver}  from "@Common/ui-components/dom-size-observer";
import {formatMoney}      from "@Common/ui-components/language/format-money";
import {buildUrlQuery}    from "@Common/utils/build-url-query";
import {CheckShowPricing} from "@Common/logic/check-show-pricing";

export const NonSubsxBenefits = ({cart}) => cs(
    ({}, next) => CheckShowPricing({next}),
    ({}, next) => !cart ? null : next(),

    consumeContext("apis"),
    consumeContext("routerHistory"),
    ["data", ({apis}, next) => Load2({
        _key: JSON.stringify(cart.items.map((i) => [i.shipping?.serviceLevel, i.shipping?.breakShippingConsolidation])),
        fetch: () => apis.next.cart.getSubscriptionBenefits({cartId: cart.cartId}),
        next,
    })],

    ({data}, next) => data.loading || !data.value?.totalSavings ? null : next(),

    ({data}, next) => data.value.result === "failure" ? (
        Error({msg: data.value.errors?.msg})
    ) : (
        next()
    ),

    ({data, routerHistory}) => (
        <div className="non-subsx-benefits non-subsx-benefits-1xm normal">
            <div className="background">
                <img className="xd" src={require("../../common/xd-logo.svg")} alt="XD+"/>
            </div>
            <div className="left">
                <div className="details">
                    <div className="message">
                        You could be saving {formatMoney(data.value.totalSavings)} with a XD+ Subscription!
                    </div>
                    <div className="actions">
                        <button {...{
                            onClick: async () => routerHistory.push('/manage-subscriptions' + buildUrlQuery({
                                referrer: "checkout",
                                id_cart: cart.cartId,
                            })),
                            "xd-qa-type": "button",
                            "xd-qa-name": "SUBSCRIBE",
                        }}>
                            SUBSCRIBE
                        </button>
                    </div>
                </div>
            </div>
            <div className="right">
                <div className="logo">
                    <img className="xd" src={require("../../common/xd-plus-logo.png")} alt="XD+"/>
                </div>
            </div>
        </div>
    ),
);

const Error = ({msg}) => (
    <div className="non-subsx-benefits non-subsx-benefits-1xm error">
        <b>Subsx benefit</b>: {msg ?? "Unknown error"}
    </div>
);
